<!-- <div class="container-fluid px-3" *ngIf="showMainContent">
  <app-inventory-create/>
  <app-inventory-mass-update-create/>
  <app-inventory-list/>
</div> -->
<router-outlet></router-outlet>